import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";

import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";

const faqs = [
	{
		question: "¿Cómo me registro?",
		answer: (
			<>
				Entra a{" "}
				<Link to="/auth/register" className="text-lightBlue-500 font-semibold">
					Crear cuenta
				</Link>{" "}
				e ingresa tu nombre, correo electrónico y contraseña. Te enviaremos un correo de
				confirmación; una vez que confirmes tu cuenta podrás iniciar sesión y comenzar a usar
				ENARM Apex.
			</>
		),
	},
	{
		question: "¿Cómo cancelo mi suscripción?",
		answer: (
			<>
				Ve a{" "}
				<Link to="/admin/mi-cuenta" className="text-lightBlue-500 font-semibold">
					Mi cuenta
				</Link>
				, busca la sección "Suscripción" y presiona "Cancelar suscripción". Tu suscripción
				seguirá activa hasta el final del periodo que ya pagaste; después de esa fecha no se
				generará ningún cargo adicional.
			</>
		),
	},
	{
		question: "¿Cómo recupero mi contraseña?",
		answer: (
			<>
				En la pantalla de{" "}
				<Link to="/auth/login" className="text-lightBlue-500 font-semibold">
					inicio de sesión
				</Link>{" "}
				da clic en "¿Olvidaste tu contraseña?" o entra directamente a{" "}
				<Link to="/auth/recuperar-contrasena" className="text-lightBlue-500 font-semibold">
					Recuperar contraseña
				</Link>
				. Ingresa tu correo electrónico y te enviaremos un enlace para crear una contraseña
				nueva.
			</>
		),
	},
	{
		question: "¿Cómo desactivo la renovación automática?",
		answer: (
			<>
				Desde{" "}
				<Link to="/admin/mi-cuenta" className="text-lightBlue-500 font-semibold">
					Mi cuenta
				</Link>{" "}
				en la sección "Suscripción" presiona "Cancelar suscripción" y confirma. Esto detiene la
				renovación automática: seguirás teniendo acceso hasta el final del periodo actual, pero
				no se te cobrará de nuevo.
			</>
		),
	},
	{
		question: "¿Puedo usar mi cuenta en varios dispositivos?",
		answer: (
			<>
				No. Por seguridad, ENARM Apex solo permite un dispositivo activo a la vez. Si inicias
				sesión en un dispositivo nuevo, podrás activar ese dispositivo, pero se cerrará la sesión
				del anterior.
			</>
		),
	},
	{
		question: "¿Qué incluye el periodo de prueba gratuito?",
		answer: (
			<>
				El periodo de prueba te da acceso completo a la plataforma (simulador, práctica,
				flashcards y estadísticas) sin costo durante un tiempo limitado. Solo puedes usarlo una
				vez por cuenta; si cancelas antes de que termine, no se te cobrará nada.
			</>
		),
	},
	{
		question: "¿Cuáles son los planes disponibles?",
		answer: (
			<>
				ENARM Apex ofrece un plan mensual ($149/mes) y un plan anual ($1490/año). Puedes
				contratarlos o cambiar entre ellos desde{" "}
				<Link to="/admin/mi-cuenta" className="text-lightBlue-500 font-semibold">
					Mi cuenta
				</Link>
				.
			</>
		),
	},
	{
		question: "¿Cómo actualizo o cambio mi plan?",
		answer: (
			<>
				Entra a{" "}
				<Link to="/admin/mi-cuenta" className="text-lightBlue-500 font-semibold">
					Mi cuenta
				</Link>
				, ve a la sección "Suscripción" y presiona "Actualizar plan" para elegir el plan que
				prefieras.
			</>
		),
	},
	{
		question: "¿Dónde veo mis facturas y recibos?",
		answer: (
			<>
				Tus recibos y facturas se gestionan desde Stripe. Entra a{" "}
				<Link to="/admin/mi-cuenta" className="text-lightBlue-500 font-semibold">
					Mi cuenta
				</Link>{" "}
				y abre el "Portal de facturación" para verlos o descargarlos.
			</>
		),
	},
	{
		question: "¿Cómo funciona el Simulador de examen?",
		answer: (
			<>
				El Simulador arma un examen con el número de preguntas, tiempo y materias que elijas,
				imitando las condiciones del ENARM real. Al terminar obtienes tus resultados y un
				desglose de tu desempeño.
			</>
		),
	},
	{
		question: "¿Cómo funcionan las Flashcards?",
		answer: (
			<>
				Las Flashcards usan repetición espaciada: calificas cada tarjeta como "otra vez",
				"difícil", "bien" o "fácil", y la plataforma ajusta cuándo volver a mostrártela para
				ayudarte a memorizar mejor.
			</>
		),
	},
	{
		question: "¿Cómo veo mi progreso y desempeño por especialidad?",
		answer: (
			<>
				En{" "}
				<Link to="/admin/estadisticas" className="text-lightBlue-500 font-semibold">
					Estadísticas
				</Link>{" "}
				y{" "}
				<Link to="/admin/especialidades" className="text-lightBlue-500 font-semibold">
					Mi desempeño
				</Link>{" "}
				puedes ver tu precisión, tiempo de estudio y avance por sección y especialidad.
			</>
		),
	},
	{
		question: "¿Puedo marcar preguntas durante el simulador o la práctica?",
		answer: (
			<>
				Sí. Durante una sesión de simulador o práctica puedes marcar cualquier pregunta para
				identificarla y volver a revisarla antes de terminar la sesión.
			</>
		),
	},
];

function FaqItem({ item, isOpen, onToggle }) {
	return (
		<div className="border-b border-blueGray-100 last:border-b-0">
			<button
				type="button"
				onClick={onToggle}
				className="w-full flex items-center justify-between gap-4 py-5 px-6 text-left focus:outline-none"
			>
				<span className="text-blueGray-700 font-semibold text-sm md:text-base">
					{item.question}
				</span>
				<ChevronDown
					size={20}
					className="text-blueGray-400 flex-shrink-0"
					style={{ transform: isOpen ? "rotate(180deg)" : "none", transition: "transform 160ms ease" }}
				/>
			</button>
			{isOpen ? (
				<div className="px-6 pb-5 text-blueGray-500 text-sm leading-relaxed">
					{item.answer}
				</div>
			) : null}
		</div>
	);
}

export default function FAQ() {
	const [openIndex, setOpenIndex] = useState(0);

	return (
		<>
			<Navbar transparent />
			<main>
				<section className="header relative pt-24 pb-24 items-center flex bg-indigo-800">
					<div className="container mx-auto items-center flex flex-wrap">
						<div className="w-full text-center">
							<h1 className="text-white font-semibold text-4xl">
								Preguntas frecuentes
							</h1>
							<p className="text-blueGray-200 mt-4 text-lg">
								Encuentra respuestas rápidas sobre tu cuenta y tu suscripción en ENARM Apex.
							</p>
						</div>
					</div>
				</section>

				<section className="relative pb-24 -mt-24 bg-indigo-800">
					<div className="container mx-auto px-4">
						<div className="w-full lg:w-8/12 mx-auto">
							<div className="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-white border-0">
								{faqs.map((item, index) => (
									<FaqItem
										key={item.question}
										item={item}
										isOpen={openIndex === index}
										onToggle={() => setOpenIndex((current) => (current === index ? -1 : index))}
									/>
								))}
							</div>
						</div>
					</div>
				</section>
			</main>
			<Footer />
		</>
	);
}
